import Breadcrumbs from '@components/layout/Breadcrumbs';
import CasesList from '@components/portal/CasesList';

/**
 * CasesPage — Support cases list
 * Route: /cases
 *
 * Tabbed list (New / In progress / Closed) with date filters + sort.
 * Layout mirrors OrdersPage for consistency across portal pages.
 */
export default function CasesPage() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Cases' }]} />
      <h1 className="font-sandvik-headline font-bold text-2xl text-carbon-black mb-6">
        My Cases
      </h1>
      <div className="bg-white border border-n2 p-6">
        <CasesList />
      </div>
    </div>
  );
}
